export const requiredFieldValidator = (value: string) =>
typeof value !== 'string' || !value.trim() ? 'Campo obrigatório.' : '';
